// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"72":"bb4935e7","481":"37fb694f"}[chunkId] + ".chunk.css";
};